import { StoryTranslationType } from "../../features/story.types";

export const story: StoryTranslationType = {
  story: {
    parts: "Parts",
    part: "Part",
    continueStory: "Continue Story",
    print: "Print",
    generatingSummary: "Generating Summary",
    generatingContinuation: "Generating Continuation",
    pleaseWait: "Please wait...",
    backToDashboard: "Back to Dashboard",
    extractCharacters: "Extract Characters",
    foundCharacters: "Found Characters",
    addSelectedCharacters: "Add Selected Characters",
    share: "Share",
    viewEntire: "View Entire Story",
    viewPaginated: "View Paginated Story",
    tooltips: {
      upgradeToContinue: "Upgrade to continue stories",
      upgradeToShare: "Upgrade to share stories",
      upgradeToExtract: "Upgrade to extract characters"
    },
    ratings: {
      submitted: "Rating submitted",
      thankYou: "Thank you for rating this story!",
      error: "Error",
      failedToSubmit: "Failed to submit rating"
    },
    sharing: {
      dialogTitle: "Share your story",
      dialogDescription: "Choose where you want to share your story",
      privacy: "Story Privacy",
      privacyLevels: {
        private: "Private",
        public: "Public",
        friends: "Friends Only"
      },
      platform: "Platform",
      selectPlatform: "Select platform",
      customMessage: "Custom Message",
      customMessagePlaceholder: "Add a message to your share...",
      shareButton: "Share Story",
      successTitle: "Story shared successfully",
      successMessage: "Your story has been shared on {{platform}}",
      authRequired: "Authentication required",
      authMessage: "Please log in to share stories."
    },
    upgrade: {
      title: "Upgrade Required",
      continueDescription: "Upgrade your account to create story sequences.",
      continueFeature: "Create story sequences with a premium subscription",
      shareDescription: "Upgrade your account to share stories.",
      shareFeature: "Share stories with a basic subscription",
      extractDescription: "Upgrade your account to extract characters.",
      extractFeature: "Extract characters with a premium subscription",
      upgradeButton: "Upgrade Now"
    }
  },
  storyEditor: {
    navigation: {
      previousPage: "Previous Page",
      continue: "Continue",
      returnToDashboard: "Return to Dashboard",
      page: "Page",
      of: "of",
      remainingPages: "Remaining Pages",
    },
    input: {
      customResponse: "Custom Response"
    },
    choices: {
      yourChoice: "Your Choice"
    },
    completedStory: {
      title: "Story Completed",
      description: "Your story has reached its conclusion!"
    },
  },
  imageGeneration:{
    ready: "Ready",
    imageReady: "Image Ready",
    insufficientCredits: "Insufficient Credits",
    needMoreCredits: "Need More Credits",
    failed: "Failed",
    processing: "Processing",
    pleaseWait: "Please wait",
    unexpectedError: "Unexpected Error",
    generateImage: "Generate Image",
    costsCredits: "Costs Credits",
    generatingImage: "Generating Image",
    credits: "credits",
    creditsLabel: "credits",
    selectImage: "Select Image",
    selectImageDescription: "Select an image to depict the event",
    selectPreferred: "Select Preferred Image",
    contentNotFound: "Content Not Found",
    saved: "Image Saved",
    imageSaved: "Image Saved",
    partialSuccess: "Partial Success",
    someImagesFailed: "Some images failed to generate",
  },
  audioGeneration: {
    insufficientCredits: "Insufficient Credits",
    generateAudio: "Generate Audio",
    generatingAudio: "Generating Audio",
    pleaseWait: "Please wait",
    failed: "Failed",
    success: "Success",
    audioReady: "Audio Ready",
    audioAvailable: "Audio Available"
  },
  storyRewrite:{
    rewritesLeft: "Rewrites Left",
    rewriteStory: "Rewrite Story",
    rewriteComplete: "Story Rewrite Complete",
    refreshingContent: "Refreshing Content",
    refreshError: "Refresh Error",
    refreshErrorMessage: "An unexpected error occurred while refreshing the story. Please try again.",
    noRewritesLeft: "No rewrites left",
    tryPageRefresh: "Try page refresh",
  },
  loadingMessages: {
    craftingTheNextChapter: "Crafting the Next Chapter",
    weavingThePlotTwists: "Weaving the Plot Twists",
    yourAdventureIsAboutToUnfold: "Your Adventure is About to Unfold",
    developingTheCharacters: "Developing the Characters",
    imaginingNewPossibilities: "Imagining New Possibilities",
  },
  success: {
    charactersSaved: "Characters Saved",
    charactersAddedToLibrary: "Characters added to character library"
  },
  storySetup: {
    titles: {
      new: "Create New Story",
      edit: "Edit Story",
      continue: "Continue Story"
    },
    basicInfo: {
      storyTitle: "Story Title",
      titlePlaceholder: "Enter a captivating title for your story",
      silverLining: "Story Description",
      descriptionPlaceholder: "Briefly describe what your story is about",
      genre: "Genre",
      selectGenre: "Select genre",
      environment: "Environment",
      selectEnvironment: "Select environment",
      theme: "Theme",
      storyLength: "Story Length",
      storyLengthWithNumberOfPages: "Story Length (Number of Pages)",
      selectLength: "Select length",
      aiSuggest: "AI Suggest",
      missingValues: "Missing Values",
      fillRequired: "Please fill all required fields",
      titleGenerated: "Title Generated",
      generationError: "Generation Error",
      tryAgain: "Try Again",
      addCustomGenre: "Add Custom Genre",
      addCustomEnvironment: "Add Custom Environment",
      addCustomTheme: "Add Custom Theme",
      autoGenerate: "Auto-generate",
      formDataGenerated: "Form Data Generated",
      dataUpdated: "Data Updated",
      formDataEnhanced: "Form Data Enhanced",
      noEnhancementsNeeded: "No enhancements needed",
      formDataUpToDate: "Form data is up to date",
      needSomeInfo: "We need some information to get started"
    },
    genres: {
      kidsStory: "Kids Story",
      fantasy: "Fantasy",
      romance: "Romance",
      adventure: "Adventure",
      contemporary: "Contemporary",
      historicalFiction: "Historical Fiction",
      scienceFiction: "Science Fiction",
      mystery: "Mystery",
      horror: "Horror",
      superhero: "Superhero",
      thriller: "Thriller"
    },
    environments: {
      urbanCity: "Urban City",
      medievalCastle: "Medieval Castle",
      spaceStation: "Space Station",
      forest: "Forest",
      desert: "Desert",
      ocean: "Ocean",
      mountain: "Mountain",
      smallTown: "Small Town",
      futuristicMetropolis: "Futuristic Metropolis",
      underwaterKingdom: "Underwater Kingdom",
      hauntedMansion: "Haunted Mansion",
      mountainCavern: "Mountain Cavern",
      dragonLair: "Dragon Lair",
      researchLaboratory: "Research Laboratory",
      futureCommunications: "Future Communications",
      magicalLibrary: "Magical Library",
      rainyNight: "Rainy Night",
      ancientTemple: "Ancient Temple"
    },
    storyLengths: {
      short: "Short",
      medium: "Medium",
      long: "Long",
      natural: "Natural"
    },
    characters: {
      name: "Name",
      description: "Description",
      title: "Characters",
      browseCharacters: "Browse Characters",
      makePublic: "Make Public"
    },
    themeSection: {
      title: "Theme"
    },
    themeOptions: {
      friendship: "Friendship",
      love: "Love",
      betrayal: "Betrayal",
      redemption: "Redemption",
      growth: "Growth",
      power: "Power",
      justice: "Justice",
      family: "Family",
      courageBravery: "Courage & Bravery",
      magicMythology: "Magic & Mythology",
      survival: "Survival",
      warConflict: "War & Conflict",
      freedomRebellion: "Freedom & Rebellion",
      violenceRevenge: "Violence & Revenge",
      passionEroticism: "Passion & Eroticism",
      quest: "Quest",
      ancientWisdom: "Ancient Wisdom",
      timeTravel: "Time Travel",
      technology: "Technology",
      paradox: "Paradox",
      knowledge: "Knowledge",
      magic: "Magic",
      discovery: "Discovery",
      identity: "Identity",
      sacrifice: "Sacrifice",
      transformation: "Transformation"
    },
    buttons: {
      create: "Create Story",
      update: "Update Story"
    },
    character: {
      name: "Character Name",
      namePlaceholder: "Enter character name",
      role: "Character Role",
      selectRole: "Select role",
      description: "Character Description",
      descriptionPlaceholder: "Describe your character",
      create: "Create Character",
      update: "Update Character",
      roles: {
        protagonist: "Protagonist",
        antagonist: "Antagonist",
        deuteragonist: "Deuteragonist",
        mentor: "Mentor",
        comic_relief: "Comic Relief",
        mysterious: "Mysterious",
        love_interest: "Love Interest",
        anti_hero: "Anti-Hero",
        sidekick: "Sidekick",
        shapeshifter: "Shapeshifter",
        guardian: "Guardian",
        catalyst: "Catalyst"
      }
    },
    success: {
      title: "Story Setup Complete",
      description: "Your story has been successfully created and is ready for your creative journey."
    },
    failure: {
      title: "Error",
      description: "Failed to save the story. Please try again.",
    },
  }
};
